import IconAdd from '@apollo/icons/default/IconAdd.svg';
import IconRemoveSolid from '@apollo/icons/default/IconRemoveSolid.svg';
import IconSuccessSolid from '@apollo/icons/default/IconSuccessSolid.svg';
import React from 'react';

export const FieldToggle = ({
  checked,
}: {
  checked: 'checked' | 'unchecked' | 'mixed';
}) => (
  <div
    className="relative flex items-center"
    title={checked === 'checked' ? 'Remove from query' : 'Add to query'}
  >
    {checked === 'checked' ? (
      <IconSuccessSolid
        role="checkbox"
        aria-checked={true}
        className="!text-icon-info"
      />
    ) : checked === 'mixed' ? (
      <IconRemoveSolid
        role="checkbox"
        aria-checked={true}
        className="!text-icon-info"
      />
    ) : (
      <IconAdd role="checkbox" aria-checked={false} />
    )}
  </div>
);
